import {RouteConfig} from 'vue-router';
import {beniRoutes} from '@/router/routes/private/beni';
import {utentiRoutes} from "@/router/routes/private/utenti";
import {accountRoutes} from "@/router/routes/private/account";

export const privateRoutes : RouteConfig = {
  path: 'private',
  component: () => import('@/views/private/PrivateView.vue'),
  children: [
    accountRoutes,
    utentiRoutes,
    beniRoutes,
  ],
  meta: {
    requiresAuth: true
  }
};
